import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { styles } from '.';

type TProps = {
  logoUrl?: string;
  locale: string;
};

const LogoSection = (props: TProps) => {
  const { logoUrl, locale } = props;

  return (
    <div className={styles.container}>
      <Link href={`/${locale}`}>
        <div className="relative w-[10rem] sm:w-[10rem] h-[4rem]">
          <Image
            src={logoUrl ?? ''}
            alt="logo"
            className="object-fit -translate-y-1 2xl:mr-2"
            fill
          />
        </div>
      </Link>
    </div>
  );
};

export default LogoSection;
